<script setup>
import { ref } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import AssistantForm from './AssistantForm.vue';

const props = defineProps({
  assistant: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();

const dialogRef = ref(null);

const handleSubmit = async ({ name }) => {
  try {
    await store.dispatch('captainAssistants/update', {
      id: props.assistant.id,
      name,
    });
    useAlert(t('CAPTAIN.ASSISTANTS.EDIT_NAME.SUCCESS_MESSAGE'));
    dialogRef.value.close();
  } catch (error) {
    const errorMessage =
      error?.message || t('CAPTAIN.ASSISTANTS.EDIT_NAME.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleCancel = () => {
  dialogRef.value.close();
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('CAPTAIN.ASSISTANTS.EDIT_NAME.TITLE')"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <AssistantForm
      :name="assistant.name"
      :submit-label="t('CAPTAIN.FORM.EDIT')"
      @submit="handleSubmit"
      @cancel="handleCancel"
    />
    <template #footer />
  </Dialog>
</template>
